var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08337 5.24998C2.08337 4.81276 2.43782 4.45831 2.87504 4.45831H17.125C17.5623 4.45831 17.9167 4.81276 17.9167 5.24998C17.9167 5.6872 17.5623 6.04165 17.125 6.04165H2.87504C2.43782 6.04165 2.08337 5.6872 2.08337 5.24998Z",
    fill: "#E72649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08337 10.0255C2.08337 9.58825 2.43782 9.23383 2.87504 9.23383H17.125C17.5623 9.23383 17.9167 9.58825 17.9167 10.0255C17.9167 10.4627 17.5623 10.8172 17.125 10.8172H2.87504C2.43782 10.8172 2.08337 10.4627 2.08337 10.0255Z",
    fill: "#E72649"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87504 14.0094C2.43782 14.0094 2.08337 14.3638 2.08337 14.8011C2.08337 15.2382 2.43782 15.5927 2.87504 15.5927H17.125C17.5623 15.5927 17.9167 15.2382 17.9167 14.8011C17.9167 14.3638 17.5623 14.0094 17.125 14.0094H2.87504Z",
    fill: "#E72649"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMenu);
export default __webpack_public_path__ + "static/media/active-menu.63e6298bb6cc556148de1a0c93d62fe9.svg";
export { ForwardRef as ReactComponent };